import React, { useEffect, useState } from "react";

export default function Toast({ toast }) {
    const [visibleToast, setVisibleToast] = useState(toast);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (toast) {
            setVisibleToast(toast);

            // Start animation after mounting
            requestAnimationFrame(() => {
                setIsVisible(true);
            });
        } else {
            // Play exit animation
            setIsVisible(false);

            const timeout = setTimeout(() => {
                setVisibleToast(null);
            }, 250);

            return () => clearTimeout(timeout);
        }
    }, [toast]);

    if (!visibleToast) return null;

    const isSuccess = visibleToast.type === "success";

    return (
        <div
            className={`
                fixed
                bottom-6
                left-1/2
                -translate-x-1/2
                z-50

                min-w-[280px]
                max-w-[calc(100vw-32px)]

                px-4
                py-3

                rounded-md

                text-sm
                font-medium

                shadow-lg

                transition-all
                duration-250
                ease-out

                ${isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-3 opacity-0"
            }

                ${
                isSuccess
                    ? "bg-green-600 text-white"
                    : "bg-red-600 text-white"
            }
            `}
        >
            {visibleToast.message}
        </div>
    );
}